import { Injectable } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { RegistratinEntityType } from '../../../../../models/enums/registration-entity-type.enum';
import { FileUploaderComponent } from '../../../../shared/file-uploader/file-uploader.component';

@Injectable()
export class InvestorCompanyInvestorDataFormGroup {

    constructor(protected formBuilder: FormBuilder) {}

    companySectionsForAgents(section: string, agentEntitiesType: string[]): string[] {
        return agentEntitiesType
            .map((entityType) => {
                switch (entityType) {
                    case RegistratinEntityType.Cotista:
                        return [ 'uploadCorporateDocuments' ];
                    default:
                        return [ 'uploadContitutionDocuments' ];
                }
            })
            .reduce((prev, value) => [ ...prev, ...value ], []);
    }
}

export class RegisterSection {
    section: string;
    fields: string[];
}
